import { useSyncExternalStore } from 'react';
import { AbstractWsConnector, wsDefaultConnector, WsConnectionStatus } from '@/ws';

export const useWsConnectionStatus = (connector: AbstractWsConnector = wsDefaultConnector): WsConnectionStatus =>
  useSyncExternalStore(
    (onStoreChange) => connector.onStatusChange(onStoreChange),
    () => connector.getStatus(),
  );
